import { IOrganizationUser } from "@home-health-notify/domain";
import { List } from "@mui/material";
import { useTranslation } from "hhn-commons";
import CenterLayout from "../layout/CenterLayout";
import { OrganizationHeader, OrgLogoutButton } from "./OrganizationList.style";
import { OrganizationListItem } from "./OrganizationListItem";

export function OrganizationList({
  orgUsers = [],
  onLogout,
}: {
  orgUsers: IOrganizationUser[];
  onLogout: () => void;
}) {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "organization" });
  return (
    <CenterLayout noPadding>
      <OrganizationHeader>{tNs("selectOrganization")}</OrganizationHeader>
      <List>
        {orgUsers.map(orgUser => {
          return (
            <OrganizationListItem
              key={orgUser.getOrgUniqueIdentifer()}
              orgUser={orgUser}
            />
          );
        })}
      </List>

      <OrgLogoutButton
        variant="contained"
        onClick={onLogout}
        data-testid="orgLogoutButton"
      >
        {t("logout")}
      </OrgLogoutButton>
    </CenterLayout>
  );
}
